<template>
  <div
    class="destination-option-card"
    :class="[orientation, { selected, 'is-disabled': disabled }]"
    @click="onClick"
  >
    <div class="card-body">
      <v-icon class="card-icon" color="#1F5FAC" size="24">{{ icon }}</v-icon>
      <div class="card-text">
        <div class="card-title">{{ title }}</div>
        <div class="card-desc">{{ description }}</div>
      </div>
    </div>
    <div v-if="$slots.action" class="card-action">
      <slot name="action"></slot>
    </div>
    <v-icon v-if="selected" class="card-check" color="#1F5FAC" size="20">mdi-check-circle</v-icon>
  </div>
</template>

<script>
export default {
  name: 'DestinationOptionCard',
  props: {
    icon: { type: String, required: true },
    title: { type: String, required: true },
    description: { type: String, default: '' },
    selected: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    orientation: { type: String, default: 'horizontal' }
  },
  methods: {
    onClick () {
      if (this.disabled) return
      this.$emit('select')
    }
  }
}
</script>

<style lang="sass" scoped>
.destination-option-card
  position: relative
  border: 1px solid #DADADA
  border-radius: 4px
  padding: 16px 18px
  cursor: pointer
  transition: border-color .15s
  background: #fff
  &:hover
    border-color: #B5B5B5
  &.selected
    border: 2px solid #1F5FAC
    padding: 15px 17px
  &.is-disabled
    cursor: default
    opacity: .55
    &:hover
      border-color: #DADADA

.card-body
  display: flex
  gap: 14px

.horizontal .card-body
  flex-direction: row
  align-items: flex-start

.vertical .card-body
  flex-direction: column
  align-items: flex-start
  gap: 9px

.card-icon
  flex-shrink: 0

.card-title
  font-size: 14px
  font-weight: 500
  color: #222
  margin-bottom: 3px

.card-desc
  font-size: 12.5px
  color: #767676
  line-height: 17px

.destination-option-card .card-check
  position: absolute
  top: 10px
  right: 10px

.card-action
  display: flex
  justify-content: flex-end
  margin-top: 12px
</style>
